import { render, staticRenderFns } from "./classroomIntelligentBody.vue?vue&type=template&id=b32f788a&scoped=true"
import script from "./classroomIntelligentBody.vue?vue&type=script&lang=js"
export * from "./classroomIntelligentBody.vue?vue&type=script&lang=js"
import style0 from "./classroomIntelligentBody.vue?vue&type=style&index=0&id=b32f788a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32f788a",
  null
  
)

export default component.exports